module.exports = __webpack_public_path__ + "img/cross_white.74b3c8ab.svg";